//ts-check
import axios from "axios";
export default {
  methods: {
    /**
     * Função que retorna a imagem do usuário que está no GIU
     * @return {Object} Objeto da imagem
     */
    getFotoPerfil() {
      return axios.get(this.CriarUrl({ resource: "usuario/foto-atual" }), {
        responseType: "blob"
      });
    }
  }
};
